// @flow

import React from 'react';
import cx from 'classnames';
import Checkmark from 'client/components/checkmark';
import SelectionListItem from 'client/components/list/selectionList/selectionListItem';
import MemberListItemName from 'client/components/member/memberListItemName';

import type { MemberType } from 'web-core/types/member';

type Props = {
  member: MemberType,
  checked: boolean,
  disabled?: boolean,
  required?: boolean,
  clickHandler?: Function,
  className?: string,
};

export default class MemberToggle extends React.PureComponent<Props> {
  static defaultProps = {
    disabled: false,
    required: false,
    className: '',
    clickHandler: () => {},
  };

  handleClick = e => this.props.clickHandler(e, this.props.member);

  render() {
    const { member, checked, disabled, required, className } = this.props;

    return (
      <SelectionListItem
        className={className}
        checked={checked}
        clickHandler={this.handleClick}
        leftContent={<MemberListItemName member={member} required={required} />}
        rightContent={<Checkmark checked={checked} className={cx({ disabled })} />} />
    );
  }
}
